"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.singleLineEmptyQuery = void 0;
exports.singleLineEmptyQuery = {
    query: '',
    tokens: [],
};
//# sourceMappingURL=singleLineEmptyQuery.js.map